import { proxy, useSnapshot } from 'valtio';

interface IPageNameStore {
    pageName: String;
    prePageName: String;
    regionName : String;
    searchRegion: String;
    searchType: String;
    isSearch: boolean;
    applyContract: String;
    updateId: String;
    isSearchSuccess: boolean;
    getIsSearchSuccess: () => boolean;
    getUpdateId: () => String;
    getPageName: () => String;
    getIsSearch: () => String;
    getProductClass : (name: String[]) => String[];
    getProductInformation: (name: String) => String[];
    getIndustrialCases: (name: String) => String[];
    getIndustryDic: (name: String) => String[];
    setPageName: (name : String) => void;
    setIsSearch: (isSearch: boolean) => void;
    setPrePageName: (name : String) => void;
    setRegionName: (name : String) => void;
    setSearchRegion: (name: String) => void;
    setSearchType: (name: String) => void;
    setApplyContract: (applyContract: String) => void;
    setUpdateId: (id: String) => void;
    setIsSearchSuccess: (isSuccess: boolean) => void;
}

const getProductClasses = (res: any, name : String[], level: number) => {
    if(level === name.length || res === null || name[level] === '' || name[level] === undefined || res.length === 0) {
        return [];
    }
    for (let i = 0; i < res.length; i++) {
        if (res[i].categoriesCode === name[level]) {
            return [res[i].categoriesName, ...getProductClasses(res[i].children, name, level + 1)];
        }
    }
    return [];
}

const getProductInfo = (res: any, name: String, level: number) => {
    if(res === null || name === '' || name === undefined || res.length === 0) {
        return [];
    }
    for (let i = 0; i < res.length; i++) {
        if (res[i].id === name) {
            return [res[i].title];
        } else {
            if(getProductInfo(res[i].child, name, level + 1).length > 0) {
                return [res[i].title, ...getProductInfo(res[i].child, name, level + 1)];
            }
        }
    }
    return [];
}

const getIndustryDictionary = (res: any, name: String, level: number) => {
    if(res === null || name === '' || name === undefined || res.length === 0) {
        return [];
    }
    for (let i = 0; i < res.length; i++) {
        if (res[i].id === name) {
            return [res[i].title];
        } else {
            if(getIndustryDictionary(res[i].subCategoryList, name, level + 1).length > 0) {
                return [res[i].title, ...getIndustryDictionary(res[i].subCategoryList, name, level + 1)];
            }
        }
    }
    return [];
}

const state = proxy<IPageNameStore>({
    pageName : '-',
    prePageName: '-',
    regionName: '-',
    searchRegion: '-',
    searchType: '-',
    isSearch: false,
    applyContract: '',
    updateId: '-',
    isSearchSuccess: false,
    getUpdateId() {
        return state.updateId;
    },
    getPageName() {
        return state.pageName;
    },
    getProductClass(name : String[]) {
        if(sessionStorage.getItem('productClass')) {
            const res2 = sessionStorage.getItem('productClass');
            const res1 = JSON.parse(res2);
            const res = res1.res;
            return getProductClasses(res, name, 0);
        }
        return [];
    },
    getProductInformation(name: String) {
        if(sessionStorage.getItem('ProductInfo')) {
            const res2 = sessionStorage.getItem('ProductInfo');
            const res1 = JSON.parse(res2);
            const res = res1.res;
            return getProductInfo(res, name, 0);
        }
        return []
    },
    getIndustrialCases(name: String) {
        if(sessionStorage.getItem('IndustryCases')) {
            const res2 = sessionStorage.getItem('IndustryCases');
            const res1 = JSON.parse(res2);
            const res = res1.res;
            return getProductInfo(res, name, 0);
        }
        return [];
    },
    getIndustryDic(name: String) {
        if(sessionStorage.getItem('industrialDictionary')) {
            const res2 = sessionStorage.getItem('industrialDictionary');
            const res1 = JSON.parse(res2);
            const res = res1.res;
            return getIndustryDictionary(res, name, 0);
        }
        return [];
    },
    getIsSearchSuccess() {
        return state.isSearchSuccess;
    },
    getIsSearch() {
        return state.isSearch;
    },
    setPageName(name: String) {
        state.pageName = name;
    },
    setPrePageName(name : String) {
        state.prePageName = name;
    },
    setRegionName(name : String) {
        state.regionName = name;
    },
    setSearchRegion(name: String) {
        state.searchRegion = name;
    },
    setSearchType(name: String) {
        state.searchType = name;
    },
    setIsSearch(isSearch: boolean) {
        state.isSearch = isSearch;
    },
    setApplyContract(applyContract: String) {
        state.applyContract = applyContract;
    },
    setUpdateId(id) {
        state.updateId = id;
    },
    setIsSearchSuccess(isSuccess) {
        state.isSearchSuccess = isSuccess;
    },
  });
  
  export const pageNameStore = state;
  
  /** 获取页面名称全局状态 */
  export const useSnapshotPageName = () => useSnapshot(pageNameStore) as IPageNameStore;